import { CLIMBING_STYLES } from '../constants.js';
import { SPORT_CLEAN_ASCENT_TYPES, BOULDER_CLEAN_ASCENT_TYPES } from '../gradeUtils.js';

// CGP/day at a grade G:
//   N_G = clean ascents at grade G
//   D_G = unique calendar dates with any logged entry at grade G (sends + projecting)
//   CGP/day_G = log2(N_G * 2^G / D_G)  (or natural-log / e^G for bouldering)
// Grades with no clean ascents are dropped — they have no CGP value to express.
export const calculateCgpPerGrade = (data, climbingStyle) => {
  if (!data?.length) return [];

  const isBoulder = climbingStyle === CLIMBING_STYLES.BOULDER;
  const cleanTypes = isBoulder ? BOULDER_CLEAN_ASCENT_TYPES : SPORT_CLEAN_ASCENT_TYPES;

  const byGrade = new Map();

  data.forEach(ascent => {
    const rawGrade = isBoulder ? ascent.vgrade : ascent.ewbanks;
    if (rawGrade === null || isNaN(rawGrade)) return;
    const grade = Math.round(rawGrade);

    let entry = byGrade.get(grade);
    if (!entry) {
      entry = { grade, cleanCount: 0, attemptDays: new Set() };
      byGrade.set(grade, entry);
    }

    entry.attemptDays.add(ascent['Ascent Date'].split('T')[0]);

    if (cleanTypes.includes(ascent['Ascent Type']) && ascent.isClean) {
      entry.cleanCount += 1;
    }
  });

  return Array.from(byGrade.values())
    .filter(g => g.cleanCount > 0)
    .map(g => {
      const days = g.attemptDays.size;
      const perAscent = isBoulder ? Math.exp(g.grade) : Math.pow(2, g.grade);
      const linearPerDay = (g.cleanCount * perAscent) / days;
      const cgpPerDay = isBoulder ? Math.log(linearPerDay) : Math.log2(linearPerDay);
      return {
        grade: g.grade,
        cgpPerDay: Number(cgpPerDay.toFixed(3)),
        cleanCount: g.cleanCount,
        attemptDays: days
      };
    })
    .sort((a, b) => a.grade - b.grade);
};
